import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import MetricsService from 'cio/services/metrics';
import NewsletterModel from 'cio/models/newsletter';
import NewsletterOverviewTestController from './controller';
import Transition from '@ember/routing/-private/transition';

export default class TestRoute extends Route {
  @service('metrics') metricsService!: MetricsService;

  model() {
    return this.modelFor('broadcasts.newsletter');
  }

  afterModel(model: NewsletterModel, transition: Transition) {
    super.afterModel(model, transition);

    return model.findRecipients();
  }

  setupController(controller: NewsletterOverviewTestController, model: NewsletterModel, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.fetchMetrics.perform();
  }

  resetController(controller: NewsletterOverviewTestController) {
    controller.setDefaults();
  }
}
